<template>
  <a-form class="form-box">
    <a-form-item>
      <template #label>
        <span>商品名称</span>
      </template>
      <a-input v-model:value="params.keywords" placeholder="请输入商品名称" allowClear style="width: 155px" />
    </a-form-item>
    <a-form-item>
      <template #label>
        <span>上游商品ID</span>
      </template>
      <a-input v-model:value="params.outGoodsId" placeholder="请输入上游商品ID" allowClear style="width: 161px" />
    </a-form-item>
    <a-form-item>
      <template #label>
        <span>SPU编号</span>
      </template>
      <a-input v-model:value="params.goodsId" placeholder="请输入SPU编号" allowClear style="width: 175px" />
    </a-form-item>
    <a-form-item>
      <template #label>
        <span>操作状态</span>
      </template>
      <a-select
        v-model:value="params.status"
        placeholder="请选择操作状态"
        style="width: 160px"
        @change="sendData('search')"
      >
        <a-select-option v-for="item in statusList" :key="item.value" :value="item.value">{{
          item.label
        }}</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item v-if="false">
      <template #label>
        <span>所属平台</span>
      </template>
      <span>1688</span>
      <!-- <a-select
        v-model:value="params.type"
        placeholder="请选择所属平台"
        style="width: 140px" @change="sendData('search')"
      >
        <a-select-option v-for="item in platformList" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
      </a-select> -->
    </a-form-item>
    <a-form-item>
      <SynchronizationData :selectedRows="list" @finish="sendData" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" danger @click="gotoGoodManage()">批量删除商品</a-button>
    </a-form-item>
    <a-form-item>
      <a-space>
        <a-button type="primary" @click="sendData('search')">
          <SearchOutlined />
          搜索
        </a-button>
        <a-button type="primary" danger @click="sendData('reset')">
          <SyncOutlined />
          刷新
        </a-button>
        <a-button type="primary" danger @click="preview">
          <FileSearchOutlined />
          铺货预览 &nbsp;&nbsp;
          <template v-if="list.length">({{ list.length }})</template>
        </a-button>
        <a-button v-if="!list.length" disabled> <DeleteOutlined /> 批量删除 </a-button>
        <a-popconfirm
          v-else
          overlayClassName="single-invalid-coupon-popover"
          placement="left"
          trigger="hover"
          @confirm="batchDelete"
        >
          <template #title>
            <h3>确定要删除已选择的【{{ list.length }}】条上货记录吗</h3>
            <p>删除记录后，是不可恢复的，如确认后可点击【确定】按钮</p>
          </template>
          <a-button type="primary" danger ghost style="cursor: default">
            <DeleteOutlined />
            批量删除 &nbsp;&nbsp;
          </a-button>
        </a-popconfirm>
        <a-button
          v-if="false"
          @click="
            openDetail(
              'https://saas.isaas.com/?productId=sas-230710JsMxnatNEm4juH95Ftg4A9#/dmOnlinemall/application/trilateral/index'
            )
          "
          type="primary"
          >打开支付宝店铺后台</a-button
        >
        <a-tag color="red" style="font-size: 14px; white-space: pre-wrap"
          >当铺货结束后，铺货状态会有延迟，稍后可点击【搜索】或者【刷新】按钮，获取最新铺货状态</a-tag
        >
      </a-space>
    </a-form-item>
  </a-form>
</template>
<script>
import { FileSearchOutlined, SearchOutlined, SyncOutlined, DeleteOutlined } from "@ant-design/icons-vue"
import SynchronizationData from "../synchronization_data"

export default {
  components: { FileSearchOutlined, SearchOutlined, SyncOutlined, DeleteOutlined, SynchronizationData },
  data() {
    return {
      params: { type: 5 },
      statusList: [
        { label: "全部", value: -1 },
        { label: "待铺货", value: 0 },
        { label: "铺货中", value: 1 },
        { label: "铺货成功", value: 2 },
        { label: "铺货失败", value: 3 },
      ],
      platformList: [
        { label: "全部平台", value: "" },
        { label: "1688", value: 5 },
        { label: "淘特", value: 6 },
      ],
    }
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    gotoGoodManage() {
      this.$router.push({ path: "/home/goodManage" })
    },
    sendData(type) {
      if (type === "reset") this.params = { type: 5 }
      this.$emit("search", { params: this.params })
    },
    openDetail(url) {
      window.open(url)
    },
    preview() {
      if (!this.list.length) return this.$message.warning("请至少选择一条【待铺货】或者【失败】的数据")
      const arr = this.list.filter((item) => [0, 3].includes(item.Status) && item.TempId)
      if (!arr.length) return this.$message.warning("请至少选择一条【待铺货】或者【失败】，并且已选择商品模板的数据")
      this.$emit("click-preview", arr)
    },
    batchDelete() {
      if (!this.list.length) return this.$message.warning("请至少选择一条数据")
      this.$emit("batch-delete", this.list)
    },
  },
}
</script>
<style scoped lang="less">
@import "./index";
</style>
